import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Components from "gatsby-theme-networked-thought/src/components/mdx-components";

export default function LatestThoughts() {
  const data = useStaticQuery(graphql`
    query LatestThoughtsQuery {
      recent: allThought(sort: { fields: [mtime], order: [DESC] }, limit: 5) {
        nodes {
          id
          slug
          mtime(formatString: "MM/DD/YYYY HH:mm")
        }
      }
    }
  `);

  return (
    <ul>
      {data.recent.nodes.map((n) => (
        <li key={`latest-${n.id}`}>
          <Components.a href={n.slug}>{n.slug}</Components.a>
        </li>
      ))}
    </ul>
  );
}
